<template>
    <label class="form-radio m-0 flex cursor-pointer items-center gap-x-1.5 select-none">
        <input v-model="model" type="radio" :name="name" :value="value" :disabled="disabled" class="hidden" />

        <div class="border-2 border-turquoise-light flex size-4 items-center justify-center">
            <div class="bg-turquoise-light/0 size-2.5"></div>
        </div>

        <span class="text-sm text-gray">{{ label }}</span>
    </label>
</template>

<script setup>
const model = defineModel({ type: [Boolean, Number, String, Array] });

defineProps({
    name: { type: String, default: null },
    value: { type: [Number, String], required: true },
    disabled: { type: [Boolean], default: false },
    label: { type: String, required: true },
});
</script>

<style>
@reference '../../../styles/pappasrw.css';

.form-radio:has(:checked) > div div {
    @apply bg-turquoise-light;
}
</style>
